<template>
  <div v-if="state.renderPopup" @click.stop="() => {}">
    <div
      ref="popup"
      class="popup-wrapper position-fixed justify-content-center align-items-start mx-5"
      style="display: none; opacity: 0"
      :style="{ transition: `opacity ${speed}ms ease-in-out` }"
    >
      <div
        @click="handleClose"
        class="popup container px-0"
        :class="{ 'full-height': fullHeight }"
        :style="{ top: styleTop }"
      >
        <div @click.stop="() => {}" class="popup-content container px-0">
          <slot></slot>
        </div>
      </div>
    </div>
    <div v-if="withOverlay">
      <Overlay
        :zIndex="100000"
        :open="open"
        :color="'rgba(13, 20, 27, 0.65)'"
        :classes="''"
        @overlayClicked="handleClose"
        :maxOpacity="overlayMaxOpacity"
      />
    </div>
  </div>
</template>

<script>
import Overlay from "./overlay.vue";

export default {
  name: "PopupBase",
  props: {
    open: {
      type: Boolean,
      default: false,
    },
    withOverlay: {
      type: Boolean,
      default: true,
    },
    speed: {
      type: Number,
      default: 250,
    },
    overlayMaxOpacity: {
      type: Number,
      default: 0.75,
    },
    overlayColor: String,
    styleTop: {
      type: String,
      default: "0",
    },
    fullHeight: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Overlay,
  },
  methods: {
    fadeIn(display = "block") {
      this.$refs["popup"].style.opacity = 0;
      this.$refs["popup"].style.display = display;
      this.$nextTick(() => {
        this.$refs["popup"].style.opacity = 1;
      });
    },
    fadeOut() {
      this.$refs["popup"].style.opacity = 0;
      setTimeout(() => {
        this.$refs["popup"].style.display = "none";
      }, this.speed);
    },
    handleClose() {
      this.$emit("closePopup");
    },
  },
  data() {
    return {
      state: {
        renderPopup: false,
      },
    };
  },
  watch: {
    open(newVal) {
      console.log(`🚀 ~ popupBase.vue ~ open ~ newVal:`, newVal)
      if (newVal) {
        this.state.renderPopup = true;
        this.$nextTick(() => {
          document.body.classList.add("overflow-hidden");
          this.fadeIn();
        });
      } else {
        document.body.classList.remove("overflow-hidden");
        this.fadeOut();
        setTimeout(() => {
          this.state.renderPopup = false;
        }, this.speed);
      }
    },
  },
  mounted() {
    if (this.open) {
      this.state.renderPopup = true;
      const popup = this.$refs["popup"];
      popup.style.display = "block";
      popup.style.opacity = 1;
    }
  },
};
</script>

<style scoped>
.popup-wrapper {
  z-index: 1000001;
}

.popup {
  position: fixed;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2001 !important;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  border-radius: 16px;
}

.popup-header-wrapper {
  position: sticky;
  top: 0;
  background: white;
  z-index: 10;
}

.full-height {
  min-height: 100%;
}

.popup::-webkit-scrollbar {
  width: 0; /* Remove scrollbar space */
  background: transparent; /* Optional: just make scrollbar invisible */
}
/* Optional: show position indicator in red */
.popup::-webkit-scrollbar-thumb {
  background: transparent;
}

@media (min-width: 768px) {
  .popup.container {
    top: 50px;
  }
}

@media (max-width: 768px) {
  .popup {
    left: 0;
    transform: unset;
  }
}
</style>
